export default function ServerInfo() {
  const servers = [
    {
      name: 'BoxPvP',
      ip: 'Windo5DJBX.aternos.me',
      status: 'online',
      players: '24/100',
      icon: 'ri-sword-line',
      comingSoon: false
    },
    {
      name: 'Skyblock',
      ip: 'emerald.magmanode.com:30515',
      status: 'online',
      players: '18/50',
      icon: 'ri-treasure-map-line',
      comingSoon: false
    }
  ];

  return (
    <section id="server-info" className="py-20 px-4 bg-[#0f1420]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Sunucu Bilgileri
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Sunucumuza bağlanmak için aşağıdaki bilgileri kullanabilirsiniz
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
          <div className="bg-gradient-to-br from-[#1a1f35] to-[#0f1420] rounded-xl p-8 border border-[#3b82f6]/20 shadow-xl">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-[#3b82f6]/20 rounded-lg flex items-center justify-center mr-4">
                <i className="ri-server-line text-2xl text-[#3b82f6]"></i>
              </div>
              <h3 className="text-2xl font-bold text-white">BoxPvP Sunucusu</h3>
            </div>
            <div className="bg-[#0a0e1a] rounded-lg p-4 mb-4">
              <div className="flex items-center justify-between">
                <code className="text-[#3b82f6] text-xl font-mono">Windo5DJBX.aternos.me</code>
                <button 
                  onClick={() => {
                    navigator.clipboard.writeText('Windo5DJBX.aternos.me');
                  }}
                  className="text-gray-400 hover:text-[#3b82f6] transition-colors cursor-pointer"
                >
                  <i className="ri-file-copy-line text-xl"></i>
                </button>
              </div>
            </div>
            <p className="text-gray-400 text-sm">
              BoxPvP modunda savaş ve rekabet dolu bir deneyim!
            </p>
          </div>

          <div className="bg-gradient-to-br from-[#1a1f35] to-[#0f1420] rounded-xl p-8 border border-[#3b82f6]/20 shadow-xl">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-[#3b82f6]/20 rounded-lg flex items-center justify-center mr-4">
                <i className="ri-server-line text-2xl text-[#3b82f6]"></i>
              </div>
              <h3 className="text-2xl font-bold text-white">Skyblock Sunucusu</h3>
            </div>
            <div className="bg-[#0a0e1a] rounded-lg p-4 mb-4">
              <div className="flex items-center justify-between">
                <code className="text-[#3b82f6] text-lg font-mono">emerald.magmanode.com:30515</code>
                <button 
                  onClick={() => {
                    navigator.clipboard.writeText('emerald.magmanode.com:30515');
                  }}
                  className="text-gray-400 hover:text-[#3b82f6] transition-colors cursor-pointer"
                >
                  <i className="ri-file-copy-line text-xl"></i>
                </button>
              </div>
            </div>
            <p className="text-gray-400 text-sm">
              Skyblock modunda hayatta kalma ve inşa etme macerası!
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-[#1a1f35] rounded-xl p-6 border border-[#3b82f6]/10 hover:border-[#3b82f6]/30 transition-all duration-300">
            <div className="w-14 h-14 bg-[#3b82f6]/20 rounded-lg flex items-center justify-center mb-4 mx-auto">
              <i className="ri-shield-check-line text-3xl text-[#3b82f6]"></i>
            </div>
            <h4 className="text-xl font-bold text-white text-center mb-2">Anti-Cheat</h4>
            <p className="text-gray-400 text-center text-sm">
              Gelişmiş anti-cheat sistemi ile adil oyun deneyimi
            </p>
          </div>

          <div className="bg-[#1a1f35] rounded-xl p-6 border border-[#3b82f6]/10 hover:border-[#3b82f6]/30 transition-all duration-300">
            <div className="w-14 h-14 bg-[#3b82f6]/20 rounded-lg flex items-center justify-center mb-4 mx-auto">
              <i className="ri-speed-up-line text-3xl text-[#3b82f6]"></i>
            </div>
            <h4 className="text-xl font-bold text-white text-center mb-2">Yüksek Performans</h4>
            <p className="text-gray-400 text-center text-sm">
              Güçlü sunucu donanımı ile lag-free deneyim
            </p>
          </div>

          <div className="bg-[#1a1f35] rounded-xl p-6 border border-[#3b82f6]/10 hover:border-[#3b82f6]/30 transition-all duration-300">
            <div className="w-14 h-14 bg-[#3b82f6]/20 rounded-lg flex items-center justify-center mb-4 mx-auto">
              <i className="ri-calendar-line text-3xl text-[#3b82f6]"></i>
            </div>
            <h4 className="text-xl font-bold text-white text-center mb-2">Açılma Zamanı</h4>
            <p className="text-gray-400 text-center text-sm">
              Hafta Sonu 13:00-21:00 arası
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
